import * as React from 'react'
import { useTranslation } from 'hooks'
import * as S from './ProductDetails.styles'

const ProductDetails: React.FC<ProductDetailsProps> = ({
  description,
  details
}) => {
  const { t } = useTranslation()

  return (
    <>
      {description ? (
        <S.ProductDetailsItem>
          <S.ProductDetailsTitle as="h4">
            {t('react_components.product.description')}
          </S.ProductDetailsTitle>
          <div
            className="body"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </S.ProductDetailsItem>
      ) : null}
      <S.ProductDetailsItem>
        <S.ProductDetailsTitle as="h4">
          {t('react_components.product.details')}
        </S.ProductDetailsTitle>

        {Object.keys(details).map((key) => (
          <S.ProductDetailsFeaturesListItem key={key}>
            <dt>{key}</dt>
            <dd
              dangerouslySetInnerHTML={{
                __html: details[`${key}`]
              }}
            />
          </S.ProductDetailsFeaturesListItem>
        ))}
      </S.ProductDetailsItem>
    </>
  )
}

interface ProductDetailsProps {
  details: Record<string, string>
  description: string
}

export default ProductDetails
